module.exports = __webpack_public_path__ + "static/media/doctor_mobile.edd074a0.jpg";